import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { AppProvider, useApp } from './context/AppContext'
import { SceneProvider } from './context/SceneContext'
import AppRouter from './router'
import Navbar from './components/Navbar'
import ErrorBoundary from './components/ErrorBoundary'

function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <SceneProvider>
          <Router>
            <div className="App min-h-screen bg-gray-50">
              <Navbar />
              <AppRouter />
            </div>
          </Router>
        </SceneProvider>
      </AppProvider>
    </ErrorBoundary>
  )
}

export default App
